import fetchIntercept, { FetchInterceptorResponse } from 'fetch-intercept'
import Session from '../../Main/Services/User/session'
import { getLoadingSetter } from '../../Main/Contexts/LoadingContext'
import { showAlert } from '../../Main/Libs/alerts'
import { KEY_LOCAL_STORAGE_TOKEN } from '../../auth/Auth.constants'

const UNAUTHORIZED = new Set([401])
let isReloading = false

const INVALID_SYNTAX = 'invalid input syntax for integer'
const BAD_REQUEST = 'Bad Request'
const MISSING_FIELDS = 'missing fields'
const SKIP_ERRORS = [
  'STATIC_SLOTS_AND_EXPRESS_SLOTS_CONFIGURATION_INACTIVE',
  'CANNOT_DELETE_RESOURCE_WITH_ASSIGNED_TASKS',
  'STORE_MUST_HAVE_CONFIGURED_SLOT_POLICIES',
  'NO_CAPACITY_CONFIGURED_FOR_STORE_IN_GIVEN_RANGE',
  'NO_SLOT_SIZE_IN_AVAILABILITY_PAYLOAD_NOR_STATIC_SLOTS_CONFIGURATION',
  'MAPS_API_ERROR',
  'TASK_ALREADY_ALLOCATED',
  'FLEET_WITH_DEFAULT_DEPARTMENT_NOT_FOUND',
  'Email already exists',
  'Email was used on a deleted user',
  'Invalid value',
  'USER_NOT_FOUND',
  'TASK_NOT_IN_EXECUTION',
  'INVALID_EMAIL_FORMAT',
  'INVALID_AVT_ROLE_ID',
  'INVALID_CLIENT_NUMBER',
  'CLIENT_NOT_FOUND',
  'AVT_ROLE_NOT_FOUND',
  'CANNOT_INCLUDE_CANCELLED_NOR_ASSIGNED_TASKS_TO_ROUTE',
  'INVALID_STORE_IDS_FORMAT',
  'STORES_NOT_FOUND',
  'TOKEN_NAME_ALREADY_EXISTS',
  'ACTIVE_TOKEN_LIMIT_REACHED',
  'TOKEN_DOES_NOT_BELONG_TO_CLIENT',
  'TOKEN_NOT_FOUND',
  'TOKEN_ALREADY_REVOKED'
]
const SKIP_ERRORS_MSG = ['THE_START_DATE_CANNOT_BE_IN_THE_PAST', 'Invalid value', 'ZONE_NAMES_MUST_BE_UNIQUE']

const EXCEPTIONS = ['^/api/shoppers/[0-9]+/card$']
const SKIP_PATH_IN_ERRORS = ['^/odin/api/job/[0-9A-Za-z-]+/flags$', '^/odin/api/job/[0-9A-Za-z-]+/history$', '^/synch/']

const includedUrls = (pathUrl: string) => {
  if (typeof pathUrl !== 'string' || pathUrl === '') return false
  if (pathUrl.startsWith('blob:') || pathUrl.startsWith('data:')) return false

  const allowedDomains = [
    'odin.instaleap.io',
    'black-panther.instaleap.io',
    'odin.xandar.instaleap.io',
    'black-panther.xandar.instaleap.io',
    'odin.vormir.instaleap.io',
    'black-panther.vormir.instaleap.io',
    'avt-backend.xandar.instaleap.io',
    'avt-backend.instaleap.io',
    'localhost'
  ]
  let urlDomain = ''
  try {
    const base = window.location.origin
    urlDomain = new URL(pathUrl, base).hostname
  } catch (_) {
    return false
  }
  return allowedDomains.some((domain) => urlDomain.includes(domain))
}
function validateExceptions(text, exceptions) {
  let re = new RegExp(exceptions.join('|'), 'i')
  return re.test(text)
}
const getTranslations = (i18n, key) => {
  const { store, language } = i18n
  let _language = language.includes('-') ? language.split('-')[0] : language
  return store.data[_language] ? store.data[_language].translation['errors'][key] : null
}
const isJSONResponse = (response) => {
  const type = response.headers.get('content-type')
  return /application\/json/.test(type)
}

const FetchIntercept = (i18n) =>
  fetchIntercept.register({
    request: async (urlOrRequestObject: string | Request, config) => {
      const urlString = urlOrRequestObject instanceof Request ? urlOrRequestObject.url : urlOrRequestObject

      if (includedUrls(urlString)) {
        if (urlOrRequestObject instanceof Request) {
          config = JSON.parse(JSON.stringify(urlOrRequestObject, ['method', 'url', 'headers', 'body']))
          config.headers.Authorization = urlOrRequestObject.headers.get('Authorization')
          config.headers['x-api-key'] = urlOrRequestObject.headers.get('x-api-key')
          config.headers['Access-Control-Allow-Origin'] = '*'
        } else {
          if (!config) config = { headers: {} }
          if (!config.headers) config.headers = {}
          config.headers.Authorization = `Bearer ${Session.get(KEY_LOCAL_STORAGE_TOKEN)}`
        }

        getLoadingSetter()(true)
        return [urlString, config]
      }

      return [urlOrRequestObject, config]
    },
    requestError: function (error) {
      return Promise.reject(error)
    },
    //@ts-ignore
    response: async function (response: FetchInterceptorResponse): Promise<FetchInterceptorResponse> {
      const { ok, url, status } = response
      const path = new URL(url).pathname
      let newResponse: FetchInterceptorResponse | any = response

      if (includedUrls(url)) {
        const showModalError = !validateExceptions(path, SKIP_PATH_IN_ERRORS)
        getLoadingSetter()(false)
        if (UNAUTHORIZED.has(status)) {
          if (!isReloading) {
            isReloading = true
            window.location.reload()
          }
          return
        }
        if (!ok && showModalError) {
          const err = await response.json()
          const error = response.statusText !== '' ? response.statusText : response.status
          if (err.message) {
            if (err.message.includes(INVALID_SYNTAX)) {
              err.message = INVALID_SYNTAX
            }
            if (err.message.includes(BAD_REQUEST)) {
              const infoError = err.message.split(':')[1]
              err.message = infoError ? infoError.trim() : err.message
            }
            if (
              err.message === MISSING_FIELDS &&
              err.payload.errors.length > 0 &&
              err.payload.errors[0].msg === 'THE_START_DATE_CANNOT_BE_IN_THE_PAST'
            ) {
              err.message = err.payload.errors[0].msg
            }
          }

          if (Array.isArray(err?.errors) && err.errors.length > 0 && SKIP_ERRORS_MSG.includes(err.errors[0].msg)) {
            err.message = err.errors[0].msg
          }

          const text = getTranslations(i18n, err.message || err.error)
          console.log('err.message', err.message)
          //Remove the if condition to show message when clients haven't dynamic slots
          if (
            !SKIP_ERRORS.includes(err.message) &&
            !SKIP_ERRORS.includes(err?.payload?.detail?.message) &&
            !SKIP_ERRORS.includes(err?.error)
          ) {
            showAlert(text || err.message || err.error || error, 'error')
          }

          if (err.payload) {
            throw new Error(`${(err && err.message) || error} | ${JSON.stringify({ payload: err.payload })}`)
          } else {
            if (SKIP_ERRORS.includes(err.error)) {
              throw err
            }
            throw new Error((err && err.message) || error)
          }
        }
        if (isJSONResponse(response)) {
          newResponse = response.json().then((json) => {
            if (ok || validateExceptions(path, EXCEPTIONS)) return json
            if (showModalError && json.message) {
              const text = getTranslations(i18n, json.message)
              showAlert(text || json.message, 'error')
            }
            throw json.message
          })
        }
      }
      return newResponse
    },
    responseError: function (error) {
      getLoadingSetter()(false)
      return Promise.reject(error)
    }
  })

export default FetchIntercept
